import { gql, useMutation } from '@apollo/client';

import { OdProtosListingsData_CustomerDeclineReason as DECLINE_REASON } from '../../../__generated__/athenaGlobalTypes';
import { LWC_DETAILS_FOR_BROKERAGE_QUERY } from '../queries/BrokerageLwcDetails';
import { LWC_DETAILS_QUERY } from '../queries/LwcDetails';
import { CustomerDecline, CustomerDeclineVariables } from './__generated__/CustomerDecline';

export const CUSTOMER_DECLINE = gql`
  mutation CustomerDecline(
    $lwcProductId: String!
    $reason: OdProtosListingsData_CustomerDeclineReason!
  ) {
    odProtosListingsServicesListwithcertaintyproduct {
      customerDecline(input: { lwcProductId: $lwcProductId, reason: $reason, actor: AGENT }) {
        _empty
      }
    }
  }
`;

/**
 * If the customer declines, this mutation should be called
 * to set the reason why they are declining
 */
export const useCustomerDecline = () => {
  const [customerDeclineMutation, { data, error, loading }] = useMutation<
    CustomerDecline,
    CustomerDeclineVariables
  >(CUSTOMER_DECLINE, {
    fetchPolicy: 'no-cache',
    context: {
      clientName: 'athena',
    },
    refetchQueries: [LWC_DETAILS_QUERY, LWC_DETAILS_FOR_BROKERAGE_QUERY],
  });

  const customerDecline = (lwcProductId: string, reason: DECLINE_REASON) =>
    customerDeclineMutation({
      variables: { lwcProductId, reason },
    });
  return { customerDecline, data, loading, error };
};
